export const pahalTypes = {
    REQUEST_DONATION_DATA: "REQUEST_DONATION_DATA",
    REQUEST_VOLUNTEER_DATA: "REQUEST_VOLUNTEER_DATA",
    REQUEST_FUNDRAISER_DATA: "REQUEST_FUNDRAISER_DATA",
  };
export const profileTypes = {
    REQUEST_CONTRIBUTIONS_DATA: "REQUEST_CONTRIBUTIONS_DATA",
    DELETE_REQUEST: "DELETE_REQUEST",
    FETCH_SCORE: "FETCH_SCORE",
    UPDATE_CONTRIBUTION_REQUEST_DATA: "UPDATE_CONTRIBUTION_REQUEST_DATA",
  };
export const userDataTypes = {
    REQUEST_PROFILE_CARD_DATA: "REQUEST_PROFILE_CARD_DATA",
    TOGGLE_SIDEBAR_STATE: "TOGGLE_SIDEBAR_STATE",
    REQUEST_USER_DATA: "REQUEST_USER_DATA",
  };